import "./SuperAdminAllTransferOutRequest.css";

import React, { useEffect, useState } from "react";

import AcceptTransferOutRequest from "Components/Popup/AcceptTransferOutRequest/AcceptTransferOutRequest";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import Headers from "Components/Header/Headers";
import Navigation from "Components/SideNavBar/Navigation";
import { getAllTransferOutRequests } from "Config/API/get";
import { modifyTransferOutRequest } from "Config/API/action";
import { toast } from "react-toastify";
import useFullPageLoader from "Hooks/useFullPageLoader";
import { raiseTransferRequestIdAction } from "Redux/action/variable.action";

import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";

const DONE_TYPING_INTERVAL = 1500;

const STATUS_COLOR = {
  pending: "#E8B81A",
  approved: "#5CA127",
  rejected: "#CB1212",
};

const CREDITS_STYLE = { color: "#5CA127", fontWeight: "bold" };

const INFO_ICON_STYLE = {
  cursor: "pointer",
  width: "22px",
  height: "22px",
  borderRadius: "50%",
  backgroundColor: "#446fa2",
  flexShrink: 0,
};

const COLUMNS = [
  { label: "DATE", render: (curr) => curr?.dateTime },
  { label: "REQUESTER", render: (curr) => curr?.userName },
  { label: "EMAIL", width: "20%", render: (curr) => curr?.email },
  { label: "ORGANIZATION", render: (curr) => curr?.organization_name },
  { label: "COMMENT", width: "25%", render: (curr) => curr?.comment },
  {
    label: "CREDITS",
    contentStyle: CREDITS_STYLE,
    render: (curr) => curr?.credit,
  },
];

const SuperAdminAllTransferOutRequest = () => {
  let typingTimer;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const token = localStorage.getItem("token");
  const [loader, setLoader, resetLoader] = useFullPageLoader();
  const [requestList, setRequestList] = useState([]);
  const [searchedText, setSearchedText] = useState("");
  const [filterType, setFilterType] = useState("");
  const [loading, setLoading] = useState(false);
  const [showAcceptRequestPopup, setShowAcceptRequestPopup] = useState(false);
  const [selectedData, setSelectedData] = useState([]);

  useEffect(() => {
    setLoader();
    getData(filterType, searchedText);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getData = (filter, searchKeywords) => {
    getAllTransferOutRequests(token, searchKeywords, filter).then((res) => {
      resetLoader();
      if (res?.status === 200) {
        setRequestList(res?.data?.data);
      }
    });
  };

  const searchData = (value) => {
    setSearchedText(value);
    getData(filterType, value);
  };

  const filterData = (value) => {
    const filter = value === "all" ? "" : value;
    setFilterType(filter);
    getData(filter, searchedText);
  };

  const changeStatus = (status, data, trn, setAcceptLoading) => {
    if (loading) return;
    setLoading(true);
    if (status === "approve") {
      modifyTransferOutRequest(token, data?.id, "approved", trn).then((res) => {
        setLoading(false);
        setAcceptLoading(false);
        if (res?.status) {
          setShowAcceptRequestPopup(false);
          getData("", "");
          toast(res?.message, { type: "success" });
        } else {
          toast(res?.message, { type: "error" });
        }
      });
    } else if (status === "reject") {
      modifyTransferOutRequest(token, data?.id, "rejected", "").then((res) => {
        setLoading(false);
        if (res?.status) {
          getData("", "");
          toast(res?.message, { type: "success" });
        } else {
          toast(res?.message, { type: "error" });
        }
      });
    }
  };

  const renderAction = (curr) => (
    <div
      style={{
        width: "110px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      {/* Status Actions / Labels */}
      <div style={{ minWidth: "80px", display: "flex", alignItems: "center" }}>
        {curr?.status?.toString() === "pending" ? (
          <div className="all-refund-status-button-container">
            <CheckIcon
              className="all-refund-status-button"
              fontSize="small"
              style={{ backgroundColor: "#5CA127" }}
              onClick={() => {
                setSelectedData(curr);
                setShowAcceptRequestPopup(true);
              }}
            />
            <CloseIcon
              className="all-refund-status-button"
              fontSize="small"
              style={{ backgroundColor: "#D81C1C" }}
              onClick={() => changeStatus("reject", curr)}
            />
          </div>
        ) : (
          <label
            style={{
              backgroundColor: STATUS_COLOR[curr?.status],
              padding: "2px 6px",
              borderRadius: "4px",
            }}
          >
            {curr?.status}
          </label>
        )}
      </div>

      {/* Info Icon */}
      <svg
        onClick={() => {
          dispatch(raiseTransferRequestIdAction(curr?.id));
          navigate("/transfer-out-request-info");
        }}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 32 32"
        fill="none"
        stroke="#fff"
        strokeWidth="3.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        style={INFO_ICON_STYLE}
      >
        <line x1="16" y1="22" x2="16" y2="12" />
        <circle cx="16" cy="8" r="2" fill="#fff" stroke="none" />
      </svg>
    </div>
  );

  return (
    <>
      <div className="all-super-admin-transfer-out-request-parent">
        <div className="all-super-admin-transfer-out-request-header">
          <Headers />
        </div>

        <div className="all-super-admin-transfer-out-request-navigation">
          <Navigation />
        </div>

        <div className="all-super-admin-transfer-out-request-main">
          <div className="all-super-admin-transfer-out-request-wrapper">
            <div className="all-super-admin-transfer-out-request-heading">
              All Transfer Out Request
            </div>
            <div className="all-super-admin-transfer-out-request-all-active">
              <div className="all-super-admin-transfer-out-request-top">
                <input
                  type="search"
                  placeholder="Search"
                  onChange={(e) => {
                    clearTimeout(typingTimer);
                    typingTimer = setTimeout(() => {
                      searchData(e.target.value);
                    }, DONE_TYPING_INTERVAL);
                  }}
                />
                <div>
                  <p>Filter:</p>
                  <select onClick={(e) => filterData(e.target.value)}>
                    <option value="all">All</option>
                    <option value="pending">PENDING</option>
                    <option value="approved">APPROVED</option>
                    <option value="rejected">REJECTED</option>
                  </select>
                </div>
              </div>
              <div className="all-super-admin-transfer-out-request-row-wrapper">
                {[...COLUMNS, { label: "ACTION" }].map(({ label, width }) => (
                  <div
                    key={label}
                    className="all-super-admin-transfer-out-request-head-row"
                    style={width ? { width } : undefined}
                  >
                    {label}
                  </div>
                ))}
              </div>
              <div className="all-super-admin-transfer-out-request-bottom">
                {requestList?.length?.toString() !== "0" ? (
                  requestList?.map((curr, index) => (
                    <div
                      className="all-super-admin-transfer-out-request-content-wrapper"
                      key={index}
                    >
                      {COLUMNS.map(({ label, width, contentStyle, render }) => (
                        <div
                          key={label}
                          className="all-super-admin-transfer-out-request-content-row"
                          style={width ? { width } : contentStyle}
                        >
                          {render(curr)}
                        </div>
                      ))}
                      <div
                        className="all-super-admin-transfer-out-request-content-row"
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        {renderAction(curr)}
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="all-super-admin-transfer-out-request-msg">
                    No Requests Found
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      {showAcceptRequestPopup && (
        <AcceptTransferOutRequest
          hide={setShowAcceptRequestPopup}
          requestDetails={selectedData}
          changeStatus={changeStatus}
        />
      )}
      {loader}
    </>
  );
};

export default SuperAdminAllTransferOutRequest;
